// extracted by mini-css-extract-plugin
export default {"container":"kN-z","modal":"lN-z","dimensions":"mN-z","brandName":"nN-z","productName":"oN-z","recipientEmail":"pN-z","recommendedFit":"qN-z","hiddenField":"rN-z"};